import React from 'react';
import { ToastContainer, toast } from 'react-toastify';
import Button from "./Button.js";
import Text from "./Text.js";
import Flex from "./Flex.js";
import Theme from "./Theme.js";
import IconUtil from "./IconUtil.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default class Toast extends React.Component {
  static contextType = Theme.Context;
  static theme = {};
  static success = (content, options = {}) => {
    const key = options.containerId || 'default';
    const theme = Toast.theme[key] || Toast.theme.default;
    const {
      className,
      successVariant,
      successMsgVariant,
      successTitleVariant,
      successButtonVariant,
      buttonVariant,
      variant,
      containerId,
      icon,
      iconOpts,
      imgOpts,
      ...rest
    } = theme.props('Toast', options?.variant || 'success', options);
    const Button = CloseButton(`${successButtonVariant}|${buttonVariant}`);
    const useIcon = icon ? IconUtil.create(icon, imgOpts, iconOpts) : undefined;
    toast.success(Toast.format(content, 'success', successTitleVariant, successMsgVariant), {
      closeButton: /*#__PURE__*/_jsx(Button, {}),
      className: theme.classes('Toast', 'toast', variant == null ? 'success' : `${successVariant}|${variant}|success`, className),
      containerId,
      icon: useIcon,
      ...rest
    });
  };
  static error = (content, options = {}) => {
    const key = options.containerId || 'default';
    const theme = Toast.theme[key] || Toast.theme.default;
    const {
      className,
      errorVariant,
      errorMsgVariant,
      errorTitleVariant,
      errorButtonVariant,
      buttonVariant,
      variant,
      containerId,
      icon,
      iconOpts,
      imgOpts,
      ...rest
    } = theme.props('Toast', options?.variant || 'error', options);
    const Button = CloseButton(`${errorButtonVariant}|${buttonVariant}`);
    const useIcon = icon ? IconUtil.create(icon, imgOpts, iconOpts) : undefined;
    toast.error(Toast.format(content, 'error', errorTitleVariant, errorMsgVariant), {
      closeButton: /*#__PURE__*/_jsx(Button, {}),
      className: theme.classes('Toast', 'toast', variant == null ? 'error' : `${errorVariant}|${variant}|error`, className),
      containerId,
      icon: useIcon,
      ...rest
    });
  };
  static warn = (content, options = {}) => {
    const key = options.containerId || 'default';
    const theme = Toast.theme[key] || Toast.theme.default;
    const {
      className,
      warnVariant,
      warnMsgVariant,
      warnTitleVariant,
      warnButtonVariant,
      buttonVariant,
      variant,
      containerId,
      icon,
      iconOpts,
      imgOpts,
      ...rest
    } = theme.props('Toast', options?.variant || 'warn', options);
    const Button = CloseButton(`${warnButtonVariant}|${buttonVariant}`);
    const useIcon = icon ? IconUtil.create(icon, imgOpts, iconOpts) : undefined;
    toast.warn(Toast.format(content, 'warn', warnTitleVariant, warnMsgVariant), {
      closeButton: /*#__PURE__*/_jsx(Button, {}),
      className: theme.classes('Toast', 'toast', variant == null ? 'warn' : `${warnVariant}|${variant}|warn`, className),
      containerId,
      icon: useIcon,
      ...rest
    });
  };
  static info = (content, options = {}) => {
    const key = options.containerId || 'default';
    const theme = Toast.theme[key] || Toast.theme.default;
    const {
      className,
      infoVariant,
      infoMsgVariant,
      infoTitleVariant,
      infoButtonVariant,
      buttonVariant,
      variant,
      containerId,
      icon,
      iconOpts,
      imgOpts,
      ...rest
    } = theme.props('Toast', options?.variant || 'info', options);
    const Button = CloseButton(`${infoButtonVariant}|${buttonVariant}`);
    const useIcon = icon ? IconUtil.create(icon, imgOpts, iconOpts) : undefined;
    toast.info(Toast.format(content, 'info', infoTitleVariant, infoMsgVariant), {
      closeButton: /*#__PURE__*/_jsx(Button, {}),
      className: theme.classes('Toast', 'toast', variant == null ? 'info' : `${infoVariant}|${variant}|info`, className),
      containerId,
      icon: useIcon,
      ...rest
    });
  };
  static custom = (content, options = {}) => {
    const key = options.containerId || 'default';
    const theme = Toast.theme[key] || Toast.theme.default;
    const {
      className,
      variant,
      msgVariant,
      titleVariant,
      buttonVariant,
      containerId,
      icon,
      iconOpts,
      imgOpts,
      ...rest
    } = theme.props('Toast', options);
    const Button = CloseButton(buttonVariant);
    const useIcon = icon ? IconUtil.create(icon, imgOpts, iconOpts) : undefined;
    toast(Toast.format(content, 'custom', titleVariant, msgVariant), {
      closeButton: /*#__PURE__*/_jsx(Button, {}),
      className: theme.classes('Toast', 'toast', variant, className),
      containerId,
      icon: useIcon,
      ...rest
    });
  };
  static format = (content, type, titleVariant, msgVariant) => {
    if (Array.isArray(content)) {
      return /*#__PURE__*/_jsx(Body, {
        content: content,
        type: type,
        titleVariant: titleVariant,
        msgVariant: msgVariant
      });
    }
    return content;
  };
  render() {
    const {
      containerId,
      ...rest
    } = this.props;
    const theme = this.context;
    const key = containerId || 'default';
    Toast.theme[key] = theme;
    return /*#__PURE__*/_jsx(ToastContainer, {
      containerId: containerId,
      ...rest
    });
  }
}
function CloseButton(variant) {
  return function ({
    closeToast
  }) {
    return /*#__PURE__*/_jsx(Button, {
      variant: `${variant}|closeToast|link`,
      onClick: closeToast,
      children: /*#__PURE__*/_jsx("i", {
        className: "fa fa-times"
      })
    });
  };
}
function Body({
  content,
  type,
  titleVariant,
  msgVariant
}) {
  return /*#__PURE__*/_jsx(Flex, {
    variant: `${type}Toast|toast`,
    direction: "column",
    children: content.map((text, index) => {
      if (index === 0 && text) {
        return /*#__PURE__*/_jsx(Text, {
          variant: `${titleVariant}|${type}ToastTitle|toastTitle`,
          children: text
        }, index); // eslint-disable-line react/no-array-index-key
      }
      return /*#__PURE__*/_jsx(Text, {
        variant: `${msgVariant}|${type}ToastMsg|toastMsg`,
        children: text
      }, index); // eslint-disable-line react/no-array-index-key
    })
  });
}